import {Component, input, model, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-dropdown-button",
    imports: [],
    templateUrl: "./dropdown-button.component.html",
    styleUrl: "./dropdown-button.component.scss",
})
export class DropdownButtonComponent {
    readonly $expanded = model(false, {alias: "expanded"})
    readonly $disabled = input(false, {alias: "disabled"})

    toggle() {
        if (this.$disabled()) return
        this.$expanded.update((expanded) => !expanded)
    }
}
